<template>
  <div>
    <ActionItemGroup>
      <Icon :title="alarmStatusTitle"
            :class="alarmStatusColorClass"
            name="bell2"
            :fixed-width="true">
      </Icon>
      <Icon :title="dataInputStatusTitle"
            :class="dataInputStatusColorClass"
            name="database-time2"
            :fixed-width="true">
      </Icon>
    </ActionItemGroup>
  </div>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';
  import Base from '~/zf/frontend/vcom/Base';
  import Icon from '../../../common/layout/Icon.vue';
  import ActionItemGroup from '../../../common/layout/ActionItemGroup.vue';

  export default {
    name: 'StatusIcons',
    components: {
      Icon,
      ActionItemGroup,
    },
    mixins: [translator],
    data() {
      return {
        alarmStatus: null,
        dataInputStatus: null,
      };
    },
    computed: {
      alarmStatusColorClass() {
        return this.getStatusColorClass(this.alarmStatus);
      },
      alarmStatusTitle() {
        return this.tr(`javascript.TX_ALARMSTATUS_${this.alarmStatus}`);
      },
      dataInputStatusColorClass() {
        return this.getStatusColorClass(this.dataInputStatus);
      },
      dataInputStatusTitle() {
        return this.tr(`javascript.TX_DATAINPUT_${this.dataInputStatus}`);
      },
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const systems = await Base.getSystems();
        const systemId = this.params.data.DT_RowId;
        if (systems !== undefined && systems[systemId] !== undefined) {
          this.alarmStatus = systems[systemId].status;
          this.dataInputStatus = systems[systemId].statusDateneingang;
        }
      },
      getStatusColorClass(statusNumber) {
        return `status-color-${statusNumber}`;
      },
    },
  };
</script>
